(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-pa-cookie-preferences]');
    if (!link || typeof window.privacyBanner?.showPreferences !== 'function') return;
    event.preventDefault();
    window.privacyBanner.showPreferences().catch(() => { window.location.href = link.href; });
  });
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector(
          'input[name="locale_code"], input[name="country_code"]',
        ),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener(
        'click',
        this.openSelector.bind(this),
      );
      this.elements.button.addEventListener(
        'focusout',
        this.closeSelector.bind(this),
      );
      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this)),
      );
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (
          this.elements.button.getAttribute('aria-expanded') === 'false'
        ).toString(),
      );
    }

    closeSelector(event) {
      const shouldClose =
        event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-instagram-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pa-instagram-gallery')) {
    customElements.define('pa-instagram-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.pa-instagram-gallery__track');
        this.controls = this.querySelector('.pa-instagram-gallery__controls');
        this.previous = this.querySelector('[data-instagram-previous]');
        this.next = this.querySelector('[data-instagram-next]');
        if (!this.track || !this.controls || !this.previous || !this.next) return;
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const update = () => {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            const maximum = this.track.scrollWidth - this.track.clientWidth;
            this.controls.hidden = maximum < 2;
            this.previous.disabled = this.track.scrollLeft <= 2;
            this.next.disabled = this.track.scrollLeft >= maximum - 2;
          });
        };
        const move = (direction) => {
          const card = this.track.querySelector('.pa-instagram-gallery__card');
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || '0');
          const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.track.scrollBy({ left: direction * step, behavior });
        };
        this.previous.addEventListener('click', () => move(-1), { signal });
        this.next.addEventListener('click', () => move(1), { signal });
        this.track.addEventListener('scroll', update, { signal, passive: true });
        this.observer?.disconnect();
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        document.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('.pa-instagram-gallery__card');
          if (card && this.contains(card)) card.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        }, { signal });
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pa-film-scroll')) {
    customElements.define('pa-film-scroll', class extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('.video-banner');
        if (!this.stage) return;
        this.media = window.matchMedia('(max-width: 749px) and (prefers-reduced-motion: no-preference)');
        this.section = this.closest('.shopify-section');
        this.queue = () => {
          if (!this.frame && this.media.matches) {
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.renderProgress();
            });
          }
        };
        this.measure = () => {
          const height = this.stage.getBoundingClientRect().height;
          this.style.setProperty('--pa-film-height', `${height}px`);
          this.classList.toggle('pa-film-scroll--active', this.media.matches);
          this.queue();
        };
        this.select = () => this.setAttribute('data-editor-selected', '');
        this.deselect = () => this.removeAttribute('data-editor-selected');
        this.media.addEventListener('change', this.measure);
        window.addEventListener('scroll', this.queue, { passive: true });
        window.addEventListener('resize', this.measure, { passive: true });
        this.section?.addEventListener('shopify:section:select', this.select);
        this.section?.addEventListener('shopify:section:deselect', this.deselect);
        this.addEventListener('focusin', this.select);
        this.addEventListener('focusout', this.deselect);
        this.observer = new ResizeObserver(this.measure);
        this.observer.observe(this.stage);
        this.measure();
      }

      renderProgress() {
        const rect = this.getBoundingClientRect();
        const top = parseFloat(getComputedStyle(this.stage).top) || 0;
        const revealDistance = Number(this.dataset.revealDistance) || 45;
        const distance = Math.max(1, (rect.height - this.stage.getBoundingClientRect().height) * revealDistance / (revealDistance + 55));
        const progress = (top - rect.top) / distance;
        const ease = (value) => {
          const p = Math.min(1, Math.max(0, value));
          return p * p * (3 - 2 * p);
        };
        this.style.setProperty('--pa-film-title', ease((progress + 0.18) / 0.48).toFixed(3));
        this.style.setProperty('--pa-film-copy', ease((progress - 0.55) / 0.30).toFixed(3));
      }

      disconnectedCallback() {
        if (!this.stage) return;
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.media?.removeEventListener('change', this.measure);
        window.removeEventListener('scroll', this.queue);
        window.removeEventListener('resize', this.measure);
        this.section?.removeEventListener('shopify:section:select', this.select);
        this.section?.removeEventListener('shopify:section:deselect', this.deselect);
        this.removeEventListener('focusin', this.select);
        this.removeEventListener('focusout', this.deselect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
